<template>
  <el-dialog title="新增合同" :visible.sync="visible" :close-on-click-modal="false" :close-on-press-escape="false" width="1100px">
    <el-form :model="data" :rules="rules" ref="addForm" label-width="130px">
      <p class="form-title">合同信息</p>
      <el-alert
        v-if="data.quoteId"
        class="quote-source-alert"
        type="success"
        :closable="false"
        show-icon
        :title="`已带入报价单 ${data.quoteNo || ''} 的商品构成`"
      />
      <el-form-item label="合同编号:" prop="contractNumCreateType">
          <el-radio-group v-model="data.contractNumCreateType">
          <el-radio :label="1">系统生成</el-radio>
          <el-radio :label="2">手动编号</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="" prop="contractNum" v-if="data.contractNumCreateType == 2">
        <el-input v-model="data.contractNum" :maxlength="32" placeholder="请输入合同编号" clearable/>
      </el-form-item>
      <el-form-item label="审批流程:" prop="approvalTemplateCode">
        <el-radio-group v-model="data.approvalTemplateCode">
          <el-radio label="moProcess">膜组件、膜元件流程</el-radio>
          <el-radio label="integrationProcess">一体化流程</el-radio>
        </el-radio-group>
        <div>
          <el-popover placement="right" width="450" trigger="hover">
            <div v-if="isRjtTenant">
              瑞洁特新流程（启用后适用，实际以本单审批记录为准）<br>
              1.膜组件、膜元件审批流程<br>
              发起人→部门经理→技术负责人→副总工→财务总监→总经理→资金会计<br>
              2.一体化审批流程<br>
              发起人→部门经理→（技术负责人、交付负责人并行审批）→副总工→财务总监→总经理→资金会计<br>
              普通审批节点无人时自动跳过并留痕；实际办理节点缺人时不能提交。
            </div>
            <div v-else>
              1.膜组件、膜元件审批流程<br>
              发起人→（销售助理、商务助理）→部门负责人→技术负责人→财务总监→销售总监→总经理→财务用印<br>
              2.一体化审批流程<br>
              发起人→（销售助理、商务助理）→部门负责人→（技术负责人、交付负责人、运维负责人并行审批）→财务总监→销售总监→总经理→财务用印<br>
            </div>
            <el-button slot="reference" type="text">查看流程说明</el-button>
          </el-popover>
        </div>
      </el-form-item>
      <el-form-item label="签约客户:" prop="customerId">
        <customer-select ref="customerSelectRef" :form-param="data" :param-list="customerList" :disabled="fromCustomerFlag || fromBusinessFlag" @change="customerChange"></customer-select>
        <span v-if="!fromCustomerFlag && !fromBusinessFlag">如果无客户信息，请<el-button type="text" @click="addCustomer">前往添加</el-button></span>
      </el-form-item>
      <el-form-item label="商机:" prop="businessId">
        <el-select v-model="data.businessId" placeholder="请选择商机" :disabled="fromBusinessFlag" filterable clearable style="width:100%">
          <el-option v-for="dict in businessList" :key="dict.businessId" :label="dict.businessName" :value="dict.businessId"/>
        </el-select>
      </el-form-item>
      <el-form-item label="合同负责人:" prop="assignUserId">
        <UserSelect v-model="data.assignUserId" placeholder="请选择负责人"></UserSelect>
      </el-form-item>
      <el-form-item label="合同类型:" prop="contractType">
        <el-select v-model="data.contractType" placeholder="请选择合同类型" clearable style="width:100%" @change="handleContractTypeChange">
          <el-option v-for="dict in typeOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
        </el-select>
      </el-form-item>
      <el-form-item v-if="isRentalContract" label="租赁到期时间:" prop="contractEndDate" required>
        <el-date-picker v-model="data.contractEndDate" value-format="yyyy-MM-dd" type="date" placeholder="选择租赁到期时间" style="width:100%"></el-date-picker>
      </el-form-item>
      <el-form-item label="是否含膜:">
        <el-checkbox v-model="data.hasMembrane" @change="handleHasMembraneChange">含膜</el-checkbox>
      </el-form-item>
      <el-form-item v-if="data.hasMembrane" label="膜面积:" prop="membraneArea">
        <el-input-number
          v-model="data.membraneArea"
          :min="0"
          :max="99999999999999"
          :precision="2"
          :controls="false"
          placeholder="请输入膜面积"
          class="crm-input-number-wrap"
        />
        <span class="el-input__suffix">㎡</span>
      </el-form-item>
      <el-form-item label="电子合同:" prop="elContractFileObjs">
        <FileUpload v-model="data.elContractFileObjs" :limit="5" :readOnly="false"
                    @on-change="handleFileChange"></FileUpload>
      </el-form-item>
      <el-form-item label="签约日期:" prop="contractSignDate">
        <el-date-picker v-model="data.contractSignDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width:100%"></el-date-picker>
      </el-form-item>
      <el-form-item label="质保期限(年)" prop="warrantyPeriod">
        <el-input v-model="data.warrantyPeriod" type="number" :maxlength="100" placeholder="请输入质保期限" clearable/>
      </el-form-item>
      <el-form-item label="质保说明" prop="warrantyDesc">
        <el-input v-model="data.warrantyDesc" :maxlength="100" placeholder="请输入质保说明" clearable/>
      </el-form-item>
      <p class="form-title">收货信息</p>
      <el-form-item label="业主" prop="ownerCustomerId">
        <el-select v-model="data.ownerCustomerId" placeholder="请选择客户名称" filterable clearable style="width:100%">
          <el-option v-for="dict in customerFilterList" :key="dict.id" :label="dict.customerName" :value="dict.id"/>
        </el-select>
      </el-form-item>
      <el-form-item label="项目区域" prop="area">
        <el-cascader v-model="data.area" :options="areaOptions" :props="{ checkStrictly: true }" filterable clearable style="width:100%"></el-cascader>
      </el-form-item>
      <el-form-item label="项目地址" prop="address">
        <el-input v-model="data.address" :maxlength="100" placeholder="请输入项目地址" clearable/>
      </el-form-item>
      <el-form-item label="收货人" prop="receiverName">
        <el-input v-model="data.receiverName" :maxlength="100" placeholder="请输入收货人" clearable/>
      </el-form-item>
      <el-form-item label="联系电话" prop="receiverMobile">
        <el-input v-model="data.receiverMobile" :maxlength="100" placeholder="请输入联系电话" clearable/>
      </el-form-item>
      <p class="form-title">合同构成</p>
      <el-button type="text" @click="handleAdd('contract')">新增</el-button>
      <el-table ref="contract" :data="data.contractCompositionList">
        <el-table-column label="商品编码" min-width="130" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.productCode || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="商品名称" min-width="150" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.productName || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="110" align="center">
          <template slot="header">
            <span class="red-text">*</span>产品类型
          </template>
          <template slot-scope="scope">
            <el-select v-model="scope.row.productType" placeholder="请选择" clearable style="width:100%">
              <el-option v-for="dict in productTypeList" :key="dict.value" :label="dict.label" :value="dict.value"/>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column min-width="120" align="center">
          <template slot="header">
            产品型号
            <el-popover ref="popover" placement="right" width="450" trigger="hover">
              <div>
                1、膜元件：请输入RGE-参数，例RGE-100<br>
                2、膜组件：请输入RGE-参数-片数，如RGE-100-100片<br>
                3、一体化和小试装备：请输入每天用吨数<br>
                4、配套设备/膜配件/技术服务/运维服务：自填<br>
              </div>
            </el-popover>
            <el-button v-popover:popover type="text" class="el-icon-info"></el-button>
          </template>
          <template slot-scope="scope">
<!--            <el-select v-model="scope.row.productModel" :placeholder="modelTips" allow-create filterable clearable style="width:100%">-->
<!--              <el-option v-for="dict in scope.row.productModelList" :key="dict.value" :label="dict.label" :value="dict.value"/>-->
<!--            </el-select>-->
            <el-input v-model="scope.row.productModel" type="text" :maxlength="50" placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column label="合同用量" width="100" align="center">
          <template slot="header">
            <span class="red-text">*</span>合同用量
          </template>
          <template slot-scope="scope">
            <el-input v-model="scope.row.contractUsage" type="number" :maxlength="32" placeholder="请输入合同用量"/>
          </template>
        </el-table-column>
        <el-table-column label="用量单位" min-width="100" align="center">
          <template slot="header">
            <span class="red-text">*</span>用量单位
          </template>
          <template slot-scope="scope">
            <el-select v-model="scope.row.usageUnit" placeholder="请选择" clearable style="width:100%">
              <el-option v-for="dict in usageUnitList" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="金额" min-width="90" align="center">
          <template slot="header">
            <span class="red-text">*</span>金额（元）
          </template>
          <template slot-scope="scope">
            <el-input v-model="scope.row.amount" type="number" class="amountClass" placeholder="请输入金额" clearable/>
          </template>
        </el-table-column>
        <el-table-column label="备注" min-width="100" align="center">
          <template slot-scope="scope">
            <el-input v-model="scope.row.remark" type="text" :maxlength="50" placeholder="请输入备注"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center" fixed="right" class-name="small-padding fixed-width">
          <template slot-scope="scope">
            <el-button v-show="data.contractCompositionList.length > 1" type="text"  @click="handleDelete('contract', scope)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <br>
      <el-form-item label="优惠金额(元)：" prop="discountAmount">
        <el-input v-model="data.discountAmount" placeholder="请输入优惠金额" clearable/>
      </el-form-item>
      <el-form-item label="优惠说明：" prop="discountDesc">
        <el-input v-model="data.discountDesc" type="textarea" :maxlength="500" show-word-limit placeholder="请输入优惠说明" clearable/>
      </el-form-item>
      <el-form-item label="总金额：">
        {{totalAmount}}元
      </el-form-item>
      <p class="form-title">回款计划</p>
      <el-button type="text" @click="handleAdd('planFund')">新增</el-button>
      <el-table ref="planFund" :data="data.planFundList">
        <el-table-column label="期数" width="80" align="center">
          <template slot-scope="scope">
            <span>{{scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column label="款项名称" min-width="100" align="center">
          <template slot="header">
            <span class="red-text">*</span>款项名称
          </template>
          <template slot-scope="scope">
            <el-select v-model="scope.row.paymentName" placeholder="请选择" allow-create filterable clearable style="width:100%">
              <el-option v-for="dict in paymentList" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="比例" min-width="120" align="center">
          <template slot="header">
            <span class="red-text">*</span>比例
          </template>
          <template slot-scope="scope">
            <el-input v-model="scope.row.paymentRatio" type="number" :maxlength="32" placeholder="请输入" style="width: 90px" clearable/> %
          </template>
        </el-table-column>
        <el-table-column label="计划回款金额（元）" width="150" align="center">
          <template slot-scope="scope">
            {{Number(scope.row.paymentRatio) * totalAmount / 100}}
          </template>
        </el-table-column>
        <el-table-column label="计划回款日期" min-width="100" align="center">
          <template slot="header">
            <span class="red-text">*</span>计划回款日期
          </template>
          <template slot-scope="scope">
            <el-date-picker v-model="scope.row.planFundDate" value-format="yyyy-MM-dd" type="date" range-separator="-" style="width:100%" placeholder="请选择"
            ></el-date-picker>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center" fixed="right" class-name="small-padding fixed-width">
          <template slot-scope="scope">
            <el-button v-show="data.planFundList.length > 1" type="text" @click="handleDelete('planFund', scope)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-form-item label="备注:" prop="remark" style="margin-top: 20px">
        <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5}" :maxlength="1000" show-word-limit v-model="data.remark" placeholder="请输入备注" clearable/>
      </el-form-item>
      <p class="form-title">审批信息</p>
      <p class="check-tips">
        合同创建后将进行审批，请确认合同信息已经更新准确。
      </p>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import UserSelect from "@/views/crm/components/userSelect";
import {querySimpleList} from "@/api/crm/business";
import {listSimpleAll} from "@/api/crm/customer";
import {createContract, queryProductTypeList} from "@/api/crm/contract";
import {getQuoteDetail} from "@/api/crm/quote";
import {listAllLevelArea} from '@/api/crm/area'
import {transferCascaderOptionsForProvince} from '@/utils'
import {gteZero2, validPhone} from "@/utils/validator";
import {mapState} from 'vuex'
import FileUpload from "@/views/crm/components/fileUpload";
import customerSelect from "@/views/crm/components/customerSelect";

const emptyContractComposition = () => ({
  amount: null,
  contractId: null,
  contractUsage: 1,
  productModel: null,
  productType: null,
  remark: "",
  usageUnit: null
})

const emptyPlanFund = () => ({
  paymentName: null,
  paymentRatio: null,
  planFundDate: null,
  remark: ""
})

const emptyContractData = () => ({
  warrantyDesc: null,
  warrantyPeriod: null,
  area: null,
  contractNumCreateType: 1,
  customerId: null,
  businessId: null,
  businessName: null,
  contractAmount: undefined,
  discountAmount: null,
  discountDesc: null,
  assignUserId: null,
  contractType: null,
  hasMembrane: false,
  membraneArea: 0,
  contractStatus: null,
  contractStartDate: null,
  contractEndDate: null,
  contractNum: null,
  customerSignContactId: null,
  ourSideSignUserId: null,
  contractSignDate: null,
  contractCompositionList: [emptyContractComposition()],
  planFundList: [emptyPlanFund()],
  elContractFileObjs: [],
  approvalTemplateCode: 'moProcess',
  remark: null,
  quoteId: null,
  quoteNo: null,
  quoteName: null
})

export default {
  name: "AddContractDialog",
  props: {
  },
  data() {
    return {
      visible: false,
      fromBusinessFlag: false,
      fromCustomerFlag: false,
      customerList: [],
      customerFilterList: [],
      businessList: [],
      areaOptions: [],
      contactList: [],
      typeOptions: [],
      productTypeList: [],
      productModelList: [],
      usageUnitList: [],
      paymentList: [],
      modelTips: '自填',
      sourceQuoteId: null,
      ownerCustomerFallback: null,
      // statusOptions: [],
      rules: {
        contractNumCreateType: [
          {required: true, type: 'number', message: '请选择生成编号方式', trigger: 'change'}
        ],
        contractNum: [
          {required: true, type: 'string', message: '请填写合同编号', trigger: 'blur'},
          {max: 32, message: '长度过长', trigger: 'blur'}
        ],
        customerId: [
          {required: true, type: 'number', message: '请选择客户', trigger: 'change'}
        ],
        discountAmount: [
          {type: 'number', validator: gteZero2, message: '请输入大于等于0的两位小数', trigger: 'change'}
        ],
        contractType: [
          {required: true, message: '请选择合同类型', trigger: 'change'}
        ],
        membraneArea: [
          {type: 'number', validator: gteZero2, message: '请输入大于等于0的两位小数', trigger: 'change'}
        ],
        contractStatus: [
          {required: true, message: '请选择合同状态', trigger: 'change'}
        ],
        assignUserId: [
          {required: true, type: 'number', message: '请选择负责人', trigger: 'change'}
        ],
        approvalTemplateCode: [
          {required: true, type: 'string', message: '请选择审批流程', trigger: 'change'}
        ],
        elContractFileObjs: [
          {required: true, message: '请上传电子合同', trigger: 'change'}
        ],
        contractSignDate: [
          {required: true, message: '请选择签约日期', trigger: 'change'}
        ],
        warrantyPeriod: [
          {required: true, message: '请输入质保期限', trigger: 'change'}
        ],
        receiverMobile: [
          {validator: validPhone, trigger: 'change'}
        ],
      },
      data: emptyContractData()
    };
  },
  created() {
    this.loadOwnerCustomerOptions();
    this.getDicts("contract_type").then(response => {
      this.typeOptions = response.data;
    });
    this.getDicts("usage_unit").then(response => {
      this.usageUnitList = response.data;
    });
    listAllLevelArea({ level: 2 }).then(response => {
      this.areaOptions = transferCascaderOptionsForProvince(response.data);
    });
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId,
      tenantId: state => state.user.tenantId
    }),
    isRjtTenant () {
      return String(this.tenantId) === '118'
    },
    totalAmount () {
      let total = 0
      total = this.data.contractCompositionList.reduce((result, item)=> {
        result += Number(item.amount)
        return result
      }, 0)
      if (this.data.discountAmount) {
        total -= Number(this.data.discountAmount)
      }
      return total
    },
    isRentalContract () {
      if (this.data.contractType === '设备租赁') return true
      const option = this.typeOptions.find(item => item.dictValue === this.data.contractType)
      return !!(option && option.dictLabel === '设备租赁')
    }
  },
  components: {
    UserSelect,
    FileUpload,
    customerSelect
  },
  watch: {
    visible (val) {
      if (!val) {
        this.resetForm("addForm");
        this.resetDialogState()
      }
    }
  },
  methods: {
    resetDialogState() {
      this.fromBusinessFlag = false
      this.fromCustomerFlag = false
      this.customerList = []
      this.businessList = []
      this.contactList = []
      this.sourceQuoteId = null
      this.ownerCustomerFallback = null
      this.data = emptyContractData()
    },
    handleAdd (type) {
      if (type == 'contract') {
        this.data.contractCompositionList.push(emptyContractComposition())
      } else {
        this.data.planFundList.push(emptyPlanFund())
      }
    },
    handleDelete (type, scope) {
      const {$index, row} = scope
      if (type == 'contract') {
        this.data.contractCompositionList.splice($index, 1)
      } else {
        this.data.planFundList.splice($index, 1)
      }
    },
    // 查询产品型号
    // queryProductModelList (row) {
    //   this.productTypeList.find(item => {
    //     if (item.value === row.productType) {
    //       this.modelTips = item.modelTips
    //       return true
    //     }
    //   })
      // this.$nextTick(() => {
      //   queryProductModelList({
      //     value: row.productType
      //   }).then(response => {
      //     const {code, msg, data} = response
      //     if (code == 200) {
      //       row.productModelList = data || [];
      //       row.productModel = null
      //       this.$refs['contract'].tableData.splice(1, 0)
      //     }
      //   })
      // }, 20)
    // },
    // 查询产品类型
    queryProductTypeList () {
      queryProductTypeList({}).then(response => {
        const {code, msg, data} = response
        if (code == 200) {
          this.productTypeList = data || [];
        }
      })
    },
    /**
     * @description 获取商机筛选列表
     * @author lee
     * @date 2021-06-07
     *
    */
    querySimpleList (customerId) {
      return querySimpleList({
        createContractFlag: 1,
        customerId: customerId
      }).then(response => {
        const {code, msg, data} = response
        if (code == 200) {
          this.businessList = data || [];
        } else {
          this.$message.error(msg || '商机列表获取失败')
        }
      }).catch(error => {
        this.$message.error(error.msg || '商机列表获取失败')
      });
    },
    loadOwnerCustomerOptions() {
      return listSimpleAll({
        customerNature: 1
      }).then(response => {
        this.customerFilterList = response.data || [];
        if (this.ownerCustomerFallback) {
          this.ensureOwnerCustomerOption(this.ownerCustomerFallback)
        }
      });
    },
    ensureOwnerCustomerOption(customer) {
      if (!customer || !customer.id) {
        return
      }
      const customerId = Number(customer.id)
      const hasCustomer = this.customerFilterList.some(item => Number(item.id) === customerId)
      if (!hasCustomer) {
        this.customerFilterList.unshift({
          id: customerId,
          customerName: customer.customerName || `客户${customerId}`
        })
      }
    },
    setDefaultOwnerCustomer(customerId, customerName) {
      if (!customerId) {
        return
      }
      const fallback = {
        id: customerId,
        customerName: customerName
      }
      this.ownerCustomerFallback = fallback
      this.ensureOwnerCustomerOption(fallback)
      if (!this.data.ownerCustomerId) {
        this.data.ownerCustomerId = customerId
      }
    },
    /**
     * @description 前往新增客户
     * @author lee
     * @date 2021-05-31
    */
    addCustomer () {
      let tempRoute = this.$router.resolve({
        path: "/crm/customer/manage"
      });
      window.open(tempRoute.href, "_blank");
    },
    open (type, id, name, customerId, customerName, assignUserId) {
      this.resetDialogState()
      if (type == 'businessId' && id && name && customerId) {
        this.data.businessId = id;
        this.data.businessName = name;
        this.data.customerId = customerId
        this.customerList = [{id: customerId, customerName: customerName}]
        this.setDefaultOwnerCustomer(customerId, customerName)
        this.fromBusinessFlag = true
      }
      if (type == 'customerId' && id && name) {
        this.data.customerId = id
        this.customerList = [{id: id, customerName: name}]
        this.setDefaultOwnerCustomer(id, name)
        this.fromCustomerFlag = true
      }
      if(assignUserId) {
        this.data.assignUserId = assignUserId;
      }else {
        this.data.assignUserId = this.currentUserId;
      }
      this.visible = true
      // to-do 接口待替换
      if (this.data.customerId) {
        this.querySimpleList(this.data.customerId)
      }
      this.queryProductTypeList()
      this.getDicts("payment_name").then(response => {
        this.paymentList = response.data;
      });
      this.$nextTick(() => {
        if (this.$refs.addForm) {
          this.$refs.addForm.clearValidate()
        }
      })
    },
    openFromQuote(quoteId) {
      this.open()
      getQuoteDetail(quoteId).then(response => {
        this.applyQuoteToContract((response && response.data) || {})
      }).catch(() => {
        this.$message.error('报价信息获取失败，请返回报价列表重试')
      })
    },
    applyQuoteToContract(detail) {
      const quote = detail.quote || {}
      const itemList = detail.itemList || []
      const contractItemList = itemList.filter(item => Number(item.amount || 0) > 0)
      const zeroAmountItemList = itemList.filter(item => Number(item.amount || 0) <= 0)
      this.sourceQuoteId = quote.id
      this.data.quoteId = quote.id
      this.data.quoteNo = quote.quoteNo
      this.data.quoteName = quote.quoteName
      this.data.customerId = quote.customerId || null
      this.data.businessId = quote.businessId || null
      this.data.businessName = quote.businessName || null
      this.data.assignUserId = quote.ownerUserId || this.currentUserId
      this.data.discountAmount = Number(quote.discountAmount || 0)
      this.data.discountDesc = quote.discountAmount ? `来源报价${quote.quoteNo || ''}优惠` : null
      this.data.remark = [
        quote.remark,
        quote.quoteNo ? `来源报价：${quote.quoteNo}` : null,
        ...zeroAmountItemList.map(item => this.formatZeroAmountQuoteItem(item)).filter(Boolean)
      ].filter(Boolean).join('\n') || null
      if (quote.customerId && quote.customerName) {
        this.customerList = [{ id: quote.customerId, customerName: quote.customerName }]
        this.setDefaultOwnerCustomer(quote.customerId, quote.customerName)
        this.querySimpleList(quote.customerId).then(() => this.ensureBusinessOption(quote))
      } else {
        this.ensureBusinessOption(quote)
      }
      this.data.contractCompositionList = contractItemList.length
        ? contractItemList.map(item => this.toContractComposition(item, quote))
        : [emptyContractComposition()]
      this.data.contractAmount = this.totalAmount
      this.$nextTick(() => {
        if (this.$refs.addForm) {
          this.$refs.addForm.clearValidate()
        }
      })
    },
    ensureBusinessOption(quote) {
      if (!quote.businessId || !quote.businessName) {
        return
      }
      const hasBusiness = this.businessList.some(item => item.businessId === quote.businessId)
      if (!hasBusiness) {
        this.businessList.unshift({ businessId: quote.businessId, businessName: quote.businessName })
      }
    },
    toContractComposition(item, quote) {
      return {
        ...emptyContractComposition(),
        quoteId: quote.id,
        quoteItemId: item.id,
        productId: item.productId,
        productCode: item.productCode,
        productName: item.productName || (Number(item.nonStandardFlag) === 1 ? '非标项' : ''),
        productVersion: item.productVersion,
        categoryName: item.categoryName,
        productType: this.resolveProductType(item),
        productModel: item.productModel,
        contractUsage: Number(item.quantity || 1),
        usageUnit: item.saleUnit || '项',
        amount: Number(item.amount || 0),
        standardPrice: item.standardPrice,
        floorPrice: item.floorPrice,
        salePrice: item.salePrice,
        standardCost: item.standardCost,
        estimatedCost: item.estimatedCost,
        grossProfit: item.grossProfit,
        grossMargin: item.grossMargin,
        pricingRuleSnapshot: item.pricingRuleSnapshot,
        deliveryScopeSnapshot: item.deliveryScopeSnapshot,
        riskFlag: item.riskFlags,
        nonStandardFlag: item.nonStandardFlag,
        remark: item.remark || ''
      }
    },
    formatZeroAmountQuoteItem(item) {
      const name = item.productName || item.productCode
      if (!name || !item.remark) {
        return null
      }
      return `${name}：${item.remark}`
    },
    resolveProductType(item) {
      const category = item.categoryName || ''
      const subCategory = item.subCategoryName || ''
      const legacyTypes = ['膜组件', '一体化', '配套设备', '运维服务', '膜元件', '小试装置', '膜配件', '技术服务']
      if (legacyTypes.includes(subCategory)) return subCategory
      if (legacyTypes.includes(category)) return category
      if (category === '服务产品') {
        return subCategory.indexOf('运维') > -1 || subCategory.indexOf('运营') > -1 ? '运维服务' : '技术服务'
      }
      if (category === '膜产品') {
        return subCategory.indexOf('配件') > -1 ? '膜配件' : '膜元件'
      }
      if (category === '成套设备') {
        return '配套设备'
      }
      return category || subCategory || '标准商品'
    },
    customerChange() {
      this.querySimpleList(this.data.customerId)
      const selectedCustomer = this.customerList.find(item => Number(item.id) === Number(this.data.customerId))
      this.setDefaultOwnerCustomer(this.data.customerId, selectedCustomer && selectedCustomer.customerName)
    },
    handleFileChange (fileObjs) {
      this.data.elContractFileObjs = fileObjs;
      this.$refs['addForm'].validateField('elContractFileObjs', (valid) => {
      })
    },
    handleHasMembraneChange (checked) {
      if (!checked) {
        this.data.membraneArea = 0
      }
      this.$nextTick(() => {
        if (this.$refs.addForm) this.$refs.addForm.clearValidate('membraneArea')
      })
    },
    handleContractTypeChange () {
      this.$nextTick(() => {
        if (this.$refs.addForm) this.$refs.addForm.clearValidate('contractEndDate')
      })
    },
    confirm () {
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          if (this.data.hasMembrane && !(Number(this.data.membraneArea) > 0)) {
            this.$message.error('含膜合同的膜面积必须大于0')
            return
          }
          if (this.isRentalContract && !this.data.contractEndDate) {
            this.$message.error('请选择租赁到期时间')
            return
          }
          if (this.isRentalContract && this.data.contractSignDate && this.data.contractEndDate < this.data.contractSignDate) {
            this.$message.error('租赁到期时间不能早于签约日期')
            return
          }
          if (this.totalAmount < 0) {
            this.$message.error('总金额不能小于0')
            return
          }
          const { contractCompositionList, planFundList } = this.data
          if (!contractCompositionList.length) {
            this.$message.error('请添加合同构成')
            return
          } else {
            // 判断参数必填项
            try {
              contractCompositionList.forEach(item => {
                if (!item.productType) throw new Error('请选择产品类型')
                if (!item.contractUsage || item.contractUsage <= 0) throw new Error('请填写大于0的合同用量')
                if (!item.usageUnit) throw new Error('请选择用量单位')
                if (!item.amount || item.amount <= 0) throw new Error('请填写大于0的合同金额')
              })
            } catch (e) {
              this.$message.error(e.message || '请检查合同构成必填项')
              return
            }
          }
          if (!planFundList.length) {
            this.$message.error('请添加回款计划')
            return
          } else {
            // 判断参数必填项
            try {
              planFundList.forEach((item, index) => {
                item.planFundBatch = index + 1
                if (!item.paymentName) throw new Error('请选择款项名称')
                if (!item.paymentRatio || item.paymentRatio <= 0) throw new Error('请填写大于0的款项比例')
                if (!item.planFundDate) throw new Error('请选择计划回款日期')
              })
            } catch (e) {
              this.$message.error(e.message || '请检查回款计划必填项')
              return
            }
          }
          const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
          });
          this.data.provinceCode = this.data.area && this.data.area.length > 0 ? this.data.area[0] : null
          this.data.cityCode = this.data.area && this.data.area.length > 1 ? this.data.area[1] : null
          this.data.regionCode = this.data.area && this.data.area.length > 2 ? this.data.area[2] : null
          this.data.contractAmount = this.totalAmount
          let params = JSON.parse(JSON.stringify(this.data));
          params.quoteId = this.sourceQuoteId || params.quoteId
          delete params.quoteNo
          delete params.quoteName
          createContract(params).then(response => {
            this.$emit('success', { quoteId: params.quoteId })
            this.visible = false
            loading.close();
            this.msgSuccess("合同新增成功");
          }).finally(() => {
            loading.close()
          })
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.form-title {
  border-left: 3px solid #4480F3;
  padding-left: 15px;
  margin-left: 15px;
  font-size: 17px;
  font-weight: bold;
}
.check-tips {
  padding-left: 15px;
  line-height: 1.8;
}
.quote-source-alert {
  margin: 0 15px 16px;
}
::v-deep .red-text {
  color: red;
}
</style>
